let initialState = {
  principalOnlyChangedToPayoff: false
};

export function payoffCheck(state = initialState, action) {
  switch (action.type) {
    case "CHECK_PAYOFF":
      return state;
    case "SET_PAYOFF_CHECK":
      return action.payload;
    case "CLEAR_PAYOFF_CHECK":
      return initialState;
    case "SET_PRINCIPAL_PAYOFF_SWITCH":
      return { principalOnlyChangedToPayoff: action.switch };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/payoffCheck.js